import { render, staticRenderFns } from "./LoadingResultado.vue?vue&type=template&id=b162e386&scoped=true&"
import script from "./LoadingResultado.vue?vue&type=script&lang=js&"
export * from "./LoadingResultado.vue?vue&type=script&lang=js&"
import style0 from "./LoadingResultado.vue?vue&type=style&index=0&id=b162e386&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b162e386",
  null
  
)

export default component.exports